var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.formGroupClass }, [
    _c("label", { staticClass: "control-label col-md-3" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-9" }, [
      _c("input", {
        ref: "inputFile",
        attrs: { id: _vm.id, type: "file", accept: _vm.accept },
        on: { change: _vm.uploadFile }
      }),
      _vm._v(" "),
      _vm.hasErrors
        ? _c("span", { staticClass: "help-block" }, [
            _c("p", [_vm._v(_vm._s(_vm.errorText))])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88671ccc", { render: render, staticRenderFns: staticRenderFns })
  }
}